Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var cn = require('classnames');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var cn__default = /*#__PURE__*/_interopDefaultCompat(cn);

var defaultColors = {"component":"skeleton__component_1t0v1","animate":"skeleton__animate_1t0v1","background":"skeleton__background_1t0v1"};
require('./default.css');

var styles = {"component":"skeleton__component_1d4jb","allowBackdropBlur":"skeleton__allowBackdropBlur_1d4jb","animate":"skeleton__animate_1d4jb"};
require('./index.css');

var invertedColors = {"component":"skeleton__component_di36y","animate":"skeleton__animate_di36y","background-inverted":"skeleton__background-inverted_di36y"};
require('./inverted.css');

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var Skeleton = function (_a) {
    var _b;
    var visible = _a.visible, _c = _a.animate, animate = _c === void 0 ? true : _c, className = _a.className, dataTestId = _a.dataTestId, children = _a.children, style = _a.style, allowBackdropBlur = _a.allowBackdropBlur, _d = _a.colors, colors = _d === void 0 ? 'default' : _d;
    if (visible) {
        return (React__default.default.createElement("div", { className: cn__default.default(styles.component, colorStyles[colors].component, (_b = {},
                _b[styles.animate] = animate,
                _b[colorStyles[colors].animate] = animate,
                _b[styles.allowBackdropBlur] = allowBackdropBlur,
                _b), className), style: style, "data-test-id": dataTestId }, children));
    }
    return (React__default.default.createElement("div", { "data-test-id": dataTestId, className: className, style: style }, children));
};

exports.Skeleton = Skeleton;
